export const FONT_FAMILY = 'YS Text';

export const TEXT_COLOR_PRIMARY = '#F7F7FFE5';
export const TEXT_COLOR_SECONDARY = '#F7F7FF80';

export const CONTAINER_BACKGROUND_COLOR = '#2E2F34';
export const CONTAINER_BORDER_RADIUS = 16;
// Накладывается поверх контейнера
export const FOOTER_BACKGROUND_COLOR = '#FFFFFF12';
